var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromijeniLozinku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_438",
    "data-name": "Group 438",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.005,
    height: 28,
    viewBox: "0 0 28.005 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 28.005,
    height: 28,
    fill: "#004c97"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M19,0a9,9,0,0,0-8.612,11.612L0,22v6H6L16.388,17.612A9,9,0,1,0,19,0m0,16a6.994,6.994,0,0,1-2.032-.3l-1.147-.348-.847.847-3.181,3.181L10.414,18,9,19.414l1.379,1.379L8.793,22.379,7.414,21,6,22.414l1.379,1.379L5.172,26H2V22.828l9.8-9.8.848-.847L12.3,11.032A7,7,0,1,1,19,16",
    fill: "#004c97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M20,6a2,2,0,1,1-2,2,2,2,0,0,1,2-2",
    fill: "#004c97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromijeniLozinku);
export default __webpack_public_path__ + "static/media/Promijeni_lozinku.aeec0144bd46a1cf9cf3cdf611365a84.svg";
export { ForwardRef as ReactComponent };